import {
  type ClientPortalCaseAlertItem,
  type ClientPortalCompanyData,
  type ClientPortalEoirCaseHistoryItem,
  type ClientPortalEoirCaseInformation,
  type ClientPortalEoirCourtInformation,
  type ClientPortalEoirCurrentStatus,
  type ClientPortalEoirDecisionAndMotion,
  type ClientPortalEoirNextHearing,
  type ClientPortalOption,
} from '@/lib/queries/case-dashboard/types'

export interface ApplicantEoirCaseItem {
  caseId: number
  currentStatus: ClientPortalEoirCurrentStatus
  history: ClientPortalEoirCaseHistoryItem[]
  caseInformation: ClientPortalEoirCaseInformation
  nextHearing: ClientPortalEoirNextHearing | null
  decisionAndMotion: ClientPortalEoirDecisionAndMotion | null
  courtInformation: ClientPortalEoirCourtInformation | null
  company: ClientPortalCompanyData
  portalOption: ClientPortalOption
  alertSchedule: ClientPortalCaseAlertItem[]
}

export const ALL_APPLICANT_EOIR_CASES: ApplicantEoirCaseItem[] = [
  {
    caseId: 1,
    currentStatus: {
      status: 'Pending',
      date: '2025-05-24T11:25:24',
    },
    history: [
      {
        status: 'Pending',
        date: '2025-05-24T11:25:24',
      },
    ],
    caseInformation: {
      alienName: 'HERNANDEZ-CAICEDO, ADELIA MARLENE',
      alienNumber: '123456789',
      docketDate: '2023-05-08',
      courtClockStatus: 'Running',
      elapsedDays: 255,
    },
    nextHearing: {
      date: 'April 29, 2026',
      time: '8:30 AM',
      type: 'Individual',
      medium: 'In Person',
      judge: 'Doolittle, Theodore',
      courtAddress: '450 MAIN ST., ROOM 628, HARTFORD, CT 06103',
    },
    decisionAndMotion: null,
    courtInformation: {
      address: '450 MAIN ST ROOM 628, HARTFORD, CT 06103',
      phoneNumber: '8602403881',
    },
    company: {
      companyId: 46,
      name: 'Lawfully, Inc.',
      email: 'lawfully@lawfully.com',
      phone: '',
      logo: 'https://lawfully-web-client-stag.s3.amazonaws.com/lawfully_pro/companyLogo/46_logo.png',
    },
    portalOption: {
      caseId: 1,
      processingTime: true,
      processingTimeTrend: true,
      inquiryDateTrend: false,
      visaBulletin: true,
      visaBulletinTrend: true,
      alertSchedule: true,
      isDefaultSetting: false,
    },
    alertSchedule: [
      {
        alertType: 'RFE',
        deadline: '2025-06-26T00:00:00Z',
        notificationTime: '2025-06-23T00:00:00Z',
        timeUnit: 'day',
        timeAgo: 3,
      },
    ],
  },
  {
    caseId: 2,
    currentStatus: {
      status: 'Affirm',
      date: '2025-05-15T12:25:24',
    },
    history: [
      {
        status: 'Affirm',
        date: '2025-05-15T12:25:24',
      },
    ],
    caseInformation: {
      alienName: 'HERNANDEZ-CAICEDO, ADELIA MARLENE',
      alienNumber: '234567890',
      docketDate: '2023-05-08',
      courtClockStatus: 'Running',
      elapsedDays: 255,
    },
    nextHearing: {
      date: 'April 29, 2026',
      time: '8:30 AM',
      type: 'Individual',
      medium: 'In Person',
      judge: 'Doolittle, Theodore',
      courtAddress: '450 MAIN ST., ROOM 628, HARTFORD, CT 06103',
    },
    decisionAndMotion: null,
    courtInformation: {
      address: '450 MAIN ST ROOM 628, HARTFORD, CT 06103',
      phoneNumber: '8602403881',
    },
    company: {
      companyId: 46,
      name: 'Lawfully, Inc.',
      email: 'lawfully@lawfully.com',
      phone: '',
      logo: 'https://lawfully-web-client-stag.s3.amazonaws.com/lawfully_pro/companyLogo/46_logo.png',
    },
    portalOption: {
      caseId: 2,
      processingTime: true,
      processingTimeTrend: true,
      inquiryDateTrend: false,
      visaBulletin: true,
      visaBulletinTrend: true,
      alertSchedule: true,
      isDefaultSetting: true,
    },
    alertSchedule: [
      {
        alertType: 'RFE',
        deadline: '2025-06-26T00:00:00Z',
        notificationTime: '2025-06-23T00:00:00Z',
        timeUnit: 'day',
        timeAgo: 3,
      },
    ],
  },
  {
    caseId: 3,
    currentStatus: {
      status: 'Pending',
      date: '2025-05-09T02:25:24',
    },
    history: [
      {
        status: 'Pending',
        date: '2025-05-09T02:25:24',
      },
    ],
    caseInformation: {
      alienName: 'HERNANDEZ-CAICEDO, ADELIA MARLENE',
      alienNumber: '345678901',
      docketDate: '2023-05-08',
      courtClockStatus: 'Running',
      elapsedDays: 255,
    },
    nextHearing: {
      date: 'April 29, 2026',
      time: '8:30 AM',
      type: 'Individual',
      medium: 'In Person',
      judge: 'Doolittle, Theodore',
      courtAddress: '450 MAIN ST., ROOM 628, HARTFORD, CT 06103',
    },
    decisionAndMotion: null,
    courtInformation: {
      address: '450 MAIN ST ROOM 628, HARTFORD, CT 06103',
      phoneNumber: '8602403881',
    },
    company: {
      companyId: 46,
      name: 'Lawfully, Inc.',
      email: 'lawfully@lawfully.com',
      phone: '',
      logo: 'https://lawfully-web-client-stag.s3.amazonaws.com/lawfully_pro/companyLogo/46_logo.png',
    },
    portalOption: {
      caseId: 3,
      processingTime: true,
      processingTimeTrend: true,
      inquiryDateTrend: false,
      visaBulletin: true,
      visaBulletinTrend: true,
      alertSchedule: false,
      isDefaultSetting: false,
    },
    alertSchedule: [],
  },
  {
    caseId: 4,
    currentStatus: {
      status: 'Affirm',
      date: '2025-05-04T11:25:24',
    },
    history: [
      {
        status: 'Affirm',
        date: '2025-05-04T11:25:24',
      },
    ],
    caseInformation: {
      alienName: 'HERNANDEZ-CAICEDO, ADELIA MARLENE',
      alienNumber: '456789012',
      docketDate: '2023-05-08',
      courtClockStatus: 'Running',
      elapsedDays: 255,
    },
    nextHearing: {
      date: 'April 29, 2026',
      time: '8:30 AM',
      type: 'Individual',
      medium: 'In Person',
      judge: 'Doolittle, Theodore',
      courtAddress: '450 MAIN ST., ROOM 628, HARTFORD, CT 06103',
    },
    decisionAndMotion: null,
    courtInformation: {
      address: '450 MAIN ST ROOM 628, HARTFORD, CT 06103',
      phoneNumber: '8602403881',
    },
    company: {
      companyId: 46,
      name: 'Lawfully, Inc.',
      email: 'lawfully@lawfully.com',
      phone: '',
      logo: 'https://lawfully-web-client-stag.s3.amazonaws.com/lawfully_pro/companyLogo/46_logo.png',
    },
    portalOption: {
      caseId: 4,
      processingTime: true,
      processingTimeTrend: true,
      inquiryDateTrend: false,
      visaBulletin: true,
      visaBulletinTrend: true,
      alertSchedule: true,
      isDefaultSetting: false,
    },
    alertSchedule: [
      {
        alertType: 'RFE',
        deadline: '2025-06-26T00:00:00Z',
        notificationTime: '2025-06-23T00:00:00Z',
        timeUnit: 'day',
        timeAgo: 3,
      },
    ],
  },
]
